export const START_FETCH = 'START_FETCH';
export const END_FETCH = 'END_FETCH';
export const FETCH_REJECTED = 'FETCH_REJECTED';
export const FETCH_REVIEWS_FULFUILED = 'FETCH_REVIEWS_FULFUILED';
export const UPDATE_PROFILE_DETAILS = 'UPDATE_PROFILE_DETAILS';
